<ng-container *transloco="let t">
  <div class="modal-header">
    <h2>{{ t('childHistory/editValueTitle') }}</h2>
    <p class="subtitle">{{ t('childHistory/editValueSubtitle', { field: fieldLabel, date: validFromLabel }) }}</p>
  </div>

  <div class="modal-body">
    <div class="form-item">
      <label class="form-label" for="history-value-input">{{ t('childHistory/editValueNewValue') }}</label>

      <select *ngIf="hasOptions" id="history-value-input" class="form-select" [formControl]="valueControl">
        <option value="">{{ t('childHistory/editValueEmptyOption') }}</option>
        <option *ngFor="let opt of fieldOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>

      <ng-container *ngIf="!hasOptions" [ngSwitch]="fieldType">
        <input *ngSwitchCase="fieldTypes.Date" id="history-value-input" class="form-control" type="date" [formControl]="valueControl" />

        <input *ngSwitchCase="fieldTypes.Number" id="history-value-input" class="form-control" type="number" [formControl]="valueControl" />

        <div *ngSwitchCase="fieldTypes.Boolean" class="form-check">
          <input id="history-value-input" class="form-check-input" type="checkbox" [formControl]="boolControl" />
          <label class="form-check-label" for="history-value-input">{{ t('shared/YES') }}</label>
        </div>

        <input
          *ngSwitchDefault
          id="history-value-input"
          class="form-control"
          type="text"
          [formControl]="valueControl"
          [placeholder]="t('childHistory/editValuePlaceholder')"
        />
      </ng-container>
    </div>

    <p class="hint">{{ t('childHistory/editValueHint') }}</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-lg btn-outline-primary" (click)="activeModal.dismiss()">
      {{ t('childHistory/cancel') }}
    </button>
    <button type="button" class="btn btn-lg btn-primary" (click)="submit()">{{ t('shared/save') }}</button>
  </div>
</ng-container>
